module.exports = __webpack_public_path__ + "img/vpn.1e797f1f.jpg";